import { SxProps } from "@mui/system";

export const containerStyle: SxProps = {
  minHeight: "610px",
  padding: "23px 47px 41px",
  borderRadius: 4,
  boxShadow: 3,
  backgroundColor: "white",
};

export const searchAndSortContainer: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "30px",
  gap: 2,
};

export const searchFieldStyle: SxProps = {
  width: "200px",
  height: "38px",

  // "& .css-1ssdlrw-MuiInputBase-root-MuiOutlinedInput-root": {
  //   paddingLeft: "8px",
  // },
  // "& .css-1jk8j0z-MuiInputBase-input-MuiOutlinedInput-input": {
  //   paddingY: "10px",
  // },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#F9FBFF",
    fontSize: "12px",
    fontFamily: "Poppins, sans-serif",
    boxShadow: 3,
  },
  "& .MuiInputBase-input": {
    padding: "10px 14px 10px 0px",
  },
};

export const checkDetailsStyles = {
  background: "#E9E9E9",
  color: "black",
  width: "80%",
  border: "1px solid black",
  padding: "6px 10px",
  borderRadius: "60px",
  cursor: "pointer",
  fontSize: "12px",
};

export const downloadButtonStyles = {
  marginRight: "1rem",
};

export const sortByContainer: SxProps = {
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F9FBFF",
  borderRadius: "10px",
  padding: "0 8px",
  height: "38px",
  boxShadow: 3,
};

export const sortByLabelStyle: SxProps = {
  marginRight: -1.1,
  color: "gray",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
  marginLeft: 0.5,
};

export const sortBySelectStyle: SxProps = {
  width: "110px",
  height: "100%",
  fontWeight: 600,
  backgroundColor: "transparent",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const mainContentStyle: SxProps = {
  minHeight: "553px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

export const paginationContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "32px",
};

export const paginationCaptionStyle: SxProps = {
  color: "#B5B7C0",
  fontFamily: "Poppins, sans-serif",
};

export const customerNameStyle: SxProps = {
  color: "#669BBC",
  cursor: "pointer",
  fontFamily: "Poppins, sans-serif",
};
